import React, { PureComponent } from 'react';
import cx from 'classnames';
import LinkHover from '../../../Buttons/Link/LinkHover';
import Button from '../../../Buttons/Button';
import Dropdown from '../../../Buttons/Dropdown/Dropdown';
import TourButtonsDrawer from './TourButtonsDrawer/TourButtonsDrawer';
import { customGaEvent, GA_EVENTS } from '../../../../utils/ga';
import './TourButtons.scss';

class TourButtons extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPanel: false,
    };
  }

  returnButtonStyles = buttonStyles => {
    const normal = buttonStyles ? buttonStyles.normal : null;
    const hover = buttonStyles ? buttonStyles.hover : null;
    return [normal, hover];
  };

  togglePanel = () => {
    const { showPanel } = this.state;
    this.setState(
      ({ showPanel }) => ({ showPanel: !showPanel }),
      () => {
        const panelState = showPanel ? 'Open' : 'Close';
        customGaEvent({
          action: GA_EVENTS.MOBILE_BUTTON_LIST,
          label: panelState,
        });
      }
    );
  };

  determineButtonStyles = buttonStyles => {
    if (buttonStyles) {
      const normal = buttonStyles.normal ? buttonStyles.normal : null;
      const hover = buttonStyles.hover ? buttonStyles.hover : null;
      return [normal, hover];
    } else {
      return [null, null];
    }
  };

  renderButtons = () => {
    const {
      buttons,
      buttonStyles,
      isMobile,
      tourId,
      tourName,
      aid,
    } = this.props;
    const sortedButtonStyles = this.determineButtonStyles(buttonStyles);
    const normal = sortedButtonStyles[0];
    const hover = sortedButtonStyles[1];

    return buttons.map(btn => {
      if (!btn.title) return null;
      return btn.type === 'standard' ? (
        <LinkHover
          tourId={tourId}
          tourName={tourName}
          key={btn.id}
          className="tour-btn"
          normal={normal}
          hover={hover}
          aid={aid}
          {...btn}
        />
      ) : (
        <Dropdown
          tourId={tourId}
          aid={aid}
          tourName={tourName}
          key={btn.id}
          className="tour-btn dropdown"
          normal={normal}
          hover={hover}
          isMobile={isMobile}
          {...btn}
        />
      );
    });
  };

  render() {
    const { buttonStyles, isMobile, buttons } = this.props;

    const { showPanel } = this.state;

    const sortedButtonStyles = this.determineButtonStyles(buttonStyles);
    const normal = sortedButtonStyles[0];

    const showIcon = isMobile && buttons.length > 1 && !showPanel;
    const buttonsExist = Boolean(buttons.length);

    const renderPseudoElement = buttonsExist && (
      <div className="render-pseudo-before">|</div>
    );

    const classes = cx({
      'tour-btns-wrapper': buttonsExist,
      'single-mobile': isMobile && buttons.length === 1,
      'desktop-single': !isMobile && buttons.length === 1,
    });

    if (isMobile) {
      return (
        <React.Fragment>
          {showIcon && (
            <Button className="open-panel-btn" handleClick={this.togglePanel}>
              <i className="material-icons">more_horiz</i>
            </Button>
          )}
          {buttons.length > 1 ? (
            <TourButtonsDrawer
              show={showPanel}
              buttons={this.renderButtons()}
              close={this.togglePanel}
              normal={normal}
            />
          ) : (
            <div className={classes}>{this.renderButtons()}</div>
          )}
        </React.Fragment>
      );
    }
    return (
      <div className={classes}>
        {renderPseudoElement}
        {this.renderButtons()}
      </div>
    );
  }
}

export default TourButtons;
